import React, { useContext, useState } from "react";
import style from "./style.module.scss";
import { Radio } from "antd";
import { PlanningForm } from "./PlanningForm";
import { MaterialRequestForm } from "./MaterialRequestForm";
import { OperationContext } from "../CreateOperation";
import { useSearchParams } from "react-router";

export const PlanningMainPage = () => {
  const { initialValue } = useContext(OperationContext);
  const [searchParams, setSearchParams] = useSearchParams();
  const sectionFromUrl = searchParams.get("section")?.toLowerCase();
  const initialSection = sectionFromUrl === "material" ? "MATERIAL" : "TEAM";

  const [selectedSection, setSelectedSection] = useState<"TEAM" | "MATERIAL">(
    initialSection
  );

  const handleSectionChange = (e: any) => {
    const value = e.target.value;
    setSelectedSection(value);

    setSearchParams((prev) => {
      const newParams = new URLSearchParams(prev.toString());

      newParams.set("section", value.toLowerCase());

      if (value === "TEAM") {
        newParams.delete("type");
      }

      return newParams;
    });
  };

  return (
    <div className={style.planning__wrapper}>
      <div className={style.planning__title_container}>
        <div className={style.planning__title_and_toggle}>
          <div className={style.planning__title_wrapper}>
            <span className={style.planning__title}>Opération : </span>
            <span className={style.planning__title_value}>
              {initialValue?.operationType?.label}
            </span>
          </div>

          <Radio.Group
            className={style.planning__toggle_radio}
            value={selectedSection}
            onChange={handleSectionChange}
            optionType="button"
            buttonStyle="solid"
          >
            <Radio.Button value="TEAM">Équipe</Radio.Button>
            <Radio.Button value="MATERIAL">Matériel</Radio.Button>
          </Radio.Group>
        </div>
      </div>

      {selectedSection === "TEAM" ? (
        <PlanningForm />
      ) : (
        <MaterialRequestForm onClose={() => setSelectedSection("TEAM")} />
      )}
    </div>
  );
};
